import "./App.css";
import Panel from "./components/Panel";

function App() {
  return (
    <div className="App">
      <Panel></Panel>
    </div>
  );
}

export default App;
